import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c76d29a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex-ter" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flexcenter" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "flex-ter-bwn"
}
const _hoisted_13 = { class: "order-tag flex-center" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { key: 4 }

import { t } from '@/plugins/i18n'
import { ref, watch, computed } from 'vue'
import STable from '@/components/Table/index.vue'
import AppLink from '@/components/common/AppLink.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { BDialogChildColumns, BDialogTableConfig } from './data'
import { inLogInfoDetail } from '@/apis/order'
import { getJapanTime } from '@/util/common'
import ProductStats from '../components/ProductStats.vue'
import ProductSku from '../components/ProductSku.vue'
import { getTrack } from '@/apis/inShipping'
import TrackDialog from '@/views/inshipping/ShippingList/TrackDialog/index.vue'
import CopyButton from '@/components/common/CopyButton.vue'
import { showCurrentUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'
import { useStore } from 'vuex'
import { jpWareInfo, ShopType } from '@/common/const'
import { isD2C } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  rowItem: {
    type: Object,
    default: () => ({})
  }
},
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props

const store = useStore()
const isTiktok = computed(() => store.getters?.shopInfo?.customerShopPlatform === ShopType.TIKTOK && isD2C())
const tableData = computed(() => {
  console.log(props.rowItem)
  return [props.rowItem]
})
const isChoice = computed(() => {
  return props.rowItem.tags.includes(4)
})

const columns: any = computed(() => {
  return [
    {
      label: t('发货单号'),
      prop: 'deliveryTaskCode'
    },
    {
      label: t('物流公司'),
      prop: 'distribution'
    },
    {
      label: t('国际物流单号'),
      prop: 'logisticsCode',
      align: 'center',
      slotName: 'logisticsCode'
    },
    {
      label: t('国际运费'),
      prop: 'freightFee',
      align: 'center',
      slotName: 'freightFee'
    },
    {
      label: props.rowItem.wareCode === jpWareInfo.warehouseCode ? `${t('计费尺寸(cm)')}` : `${t('计费重量')}(g)`,
      prop: 'weight',
      align: 'center',
      slotName: 'weight',
      choiceHidden: 1
    },
    {
      label: t('发货时间'),
      prop: 'deliveryTime',
      align: 'center',
      slotName: 'deliveryTime'
    },
    {
      label: t('发货数量'),
      prop: 'deliveryNums',
      align: 'center'
    }
  ]
})

const childColumns: any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    slotName: 'platformOrderNo'
  },
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    width: 250,
    align: 'center',
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    width: 180,
    align: 'center'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    width: 180,
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('下单数量'),
    prop: 'deliveryNums',
    align: 'center'
  }
  // {
  //   label: t('商品状态'),
  //   align: 'center',
  //   width: 160,
  //   slotName: 'shoppingStats'
  // }
]



const apiConfig = {
  listPath: 'data'
}
const trackVisible = ref(false)
const trackInfo: any = ref({})
const showTrack = (row: any) => {
  getTrack({
    deliveryTaskCode: row.deliveryTaskCode,
    logisticsCode: row.logisticsCode
  }).then((res: any) => {
    console.log(res)
    trackInfo.value = res.data
  }).finally(() => { trackVisible.value = true })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      "model-value": __props.visible,
      "destroy-on-close": "",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false))),
      draggable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(STable, {
            api: _unref(inLogInfoDetail),
            columns: _unref(columns).filter(v => !_unref(isChoice) || !v.choiceHidden),
            "filter-data": { platformOrderId: __props.rowItem.platformOrderId },
            tableConfig: _unref(BDialogTableConfig),
            "api-config": apiConfig,
            "show-pagination": false
          }, {
            expand: _withCtx(({ scope }) => [
              _createVNode(STable, {
                tableData: scope.row.platformOrderItemList,
                columns: childColumns,
                showPagination: false
              }, {
                platformOrderNo: _withCtx(({ row }) => [
                  (row.platformOrderId)
                    ? (_openBlock(), _createBlock(AppLink, {
                        key: 0,
                        to: '/d2c/order/OrderInfo/' + row.platformOrderId
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.platformOrderNo), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row.platformOrderNo), 1))
                ]),
                shoppingInfo: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(ShoppingPreview, {
                      image: row.productSkuImg || row.productMainImg || '',
                      name: row.productTitleJp || '',
                      url: row.productDetailUrl || undefined
                    }, null, 8, ["image", "name", "url"])
                  ])
                ]),
                productSku: _withCtx(({ row }) => [
                  row
                    ? (_openBlock(), _createBlock(ProductSku, {
                        key: 0,
                        row: row
                      }, null, 8, ["row"]))
                    : _createCommentVNode("", true)
                ]),
                productPropertiesName: _withCtx(({ row }) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                    return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                  }), 128))
                ]),
                shoppingStats: _withCtx(({ row }) => [
                  _createVNode(ProductStats, { row: row }, null, 8, ["row"])
                ]),
                cancel: _withCtx(({ row }) => [
                  _createVNode(_component_el_input, {
                    modelValue: row.orderQuantity,
                    "onUpdate:modelValue": ($event: any) => ((row.orderQuantity) = $event),
                    disabled: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["tableData"])
            ]),
            weight: _withCtx(({ row }) => [
              (row.wareCode === _unref(jpWareInfo).warehouseCode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (row.settleWeightType === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(row.settleThreeSideSumEnum) + _toDisplayString(row.settleThreeSideSumEnum === 999999 ? '以上' :'サイズ'), 1))
                      : (row.settleWeightType === 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('厚度')) + ":" + _toDisplayString(row.settleThickness ?? '-'), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, "-"))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(row.weight), 1))
            ]),
            deliveryTime: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.deliveryTime ?? '')), 1)
            ]),
            logisticsCode: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (showTrack(row)),
                  style: {"flex":"1"}
                }, _toDisplayString(row.logisticsCode), 9, _hoisted_11),
                _createVNode(CopyButton, {
                  text: row.logisticsCode
                }, null, 8, ["text"])
              ])
            ]),
            orderId: _withCtx(({ row }) => [
              (row.isMergeOrder)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(AppLink, {
                      to: '/d2c/user/OrderInfo/' + row.shippingId
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.orderId), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('合')), 1)
                  ]))
                : (_openBlock(), _createBlock(AppLink, {
                    key: 1,
                    to: '/d2c/user/OrderInfo/' + row.orderId
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.orderId), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ]),
            shippingId: _withCtx(({ row }) => [
              _createVNode(AppLink, {
                to: '/d2c/user/OrderInfo/' + row.shippingId
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.shippingId), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            freightFee: _withCtx(({ row }) => [
              (row.platformOrderItemList.some(i => i.allIncludeType === 2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(t)('国际运费已在下单时收取')), 1))
                : (row.wareCode === _unref(jpWareInfo).warehouseCode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(row.deliveryStatus === 5 ? `${row.freightFee}円`  : '-'), 1))
                  : (!_unref(isChoice))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(showCurrentUnit)(row.platformOrderItemList?.[0]?.goodsCountry === _unref(COUNTRY).KR, row.freightFee)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(row.platformOrderItemList?.reduce((acc, v) => acc + v.allIncludeShipPriceExchange *
              v.deliveryNums, 0)?.toFixed(0)) + "円（" + _toDisplayString(row.platformOrderItemList?.reduce((acc, v) => acc +
              v.allIncludeShipPrice * v.deliveryNums, 0)?.toFixed(2)) + "元） ", 1)),
              (row.discountFee)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(_component_el_tag, { type: "danger" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('已优惠{x}元', { x: row.discountFee })), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["api", "columns", "filter-data", "tableConfig"])
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(TrackDialog, {
      visible: trackVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((trackVisible).value = $event)),
      rowItem: trackInfo.value,
      isJPWorder: __props.rowItem.wareCode === _unref(jpWareInfo).warehouseCode
    }, null, 8, ["visible", "rowItem", "isJPWorder"])
  ], 64))
}
}

})